/**
 * all states from store
 */
export default {
  ecomm: {},
  in_request: false,
  me_store_params: {},
  assets: [],
}
